import { Skeleton } from '@accure/ui';

/**
 * Loading skeleton for system logs filters during initial data fetch.
 * Mimics the layout of the actual filter components for a smooth transition.
 */
export function FiltersLoading() {
  return (
    <div className="flex w-full flex-col gap-3">
      {/* Core filters row */}
      <div className="flex flex-wrap items-end gap-3">
        {/* Date range filter skeleton */}
        <div className="flex flex-col gap-1">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-9 w-64" />
        </div>

        {/* Type filter skeleton */}
        <div className="flex flex-col gap-1">
          <Skeleton className="h-4 w-12" />
          <Skeleton className="h-9 w-48" />
        </div>

        {/* Domain filter skeleton */}
        <div className="flex flex-col gap-1">
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-9 w-44" />
        </div>

        {/* Site filter skeleton */}
        <div className="flex flex-col gap-1">
          <Skeleton className="h-4 w-12" />
          <Skeleton className="h-9 w-44" />
        </div>

        {/* Action buttons skeleton */}
        <div className="ml-auto flex items-center gap-2">
          <Skeleton className="h-9 w-24" />
          <Skeleton className="h-9 w-20" />
        </div>
      </div>

      {/* Server-level filters row */}
      {/* <div className="border-t border-gray-200 pt-2">
        <div className="flex gap-2">
          {[1, 2, 3].map((i) => (
            <div key={i} className="flex flex-col gap-1">
              <Skeleton className="h-4 w-16" />
              <Skeleton className="h-9 w-48" />
            </div>
          ))}
        </div>
      </div> */}
    </div>
  );
}
